import { Component } from '@angular/core';
import { ScrollToService } from '../src';

@Component({
    selector: 'demo-app',
    template: require('./demo.component.html')
})
export class DemoComponent {

    constructor(private scrollService: ScrollToService) {}

    scrollToTop(element) {
        this.scrollService.scrollTo(element);
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/tslint-loader?emitErrors=false&failOnHint=false!./demo/demo.component.ts